module.exports = __webpack_public_path__ + "icon-cat.svg?22bf35ec19e736e11464b3469ee243ab";